export default __webpack_public_path__ + "static/media/spineTattoo.226e35cb.jpg";